import "./DetailCard.css";
import type React from "react";

export interface DetailField<T> {
  label: string;
  key: keyof T;
  col?: 1 | 2;
  render?: (
    value: T[keyof T],
    item: T
  ) => React.ReactNode;
  onSelect?: (
    value: T[keyof T],
    item: T
  ) => void;
}

export interface DetailSection<T> {
  title: string;
  fields: DetailField<T>[];
}

interface DetailProps<T> {
  data: T;
  sections: DetailSection<T>[];
}

export function Detail<T>({
  data,
  sections,
}: DetailProps<T>) {
  return (
    <div className="detail">

      {sections.map(section => (
        <section
          className="detail-section"
          key={section.title}
        >
          <h2>{section.title}</h2>

          <div className="detail-grid">

            {section.fields.map(field => {
              const value = data[field.key];
              const content = field.render
                ? field.render(value, data)
                : String(value ?? "-");

              return (
                <div
                  key={String(field.key)}
                  className={`detail-item col-${field.col ?? 1}`}
                >

                  <span className="detail-label">
                    {field.label}
                  </span>

                  {field.onSelect ? (
                    <button
                      type="button"
                      className="detail-value detail-value-button"
                      onClick={() => field.onSelect?.(value, data)}
                    >
                      {content}
                    </button>
                  ) : (
                    <span className="detail-value">
                      {content}
                    </span>
                  )}

                </div>
              );
            })}

          </div>

        </section>
      ))}

    </div>
  );
}
